export default __webpack_public_path__ + "static/media/Ally_Said_Babu.91443dc7.png";